import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { UserDto } from "../../../models/user/dto/user.dto";
import { UserMembershipDto } from "../../../models/user-membership/dto/user-membership.dto";
import { MembershipSubscriptionDto } from "../../../models/user-membership/dto/user-membership.dto";

export type UserWithMembershipsDto = {
  user: UserDto;
  memberships: UserMembershipDto[];
  subscriptions: MembershipSubscriptionDto[];
};

export const useGetUsersWithMemberships = (organizationId: string) => {
    const client = useApiClient();

    return useQuery({
        enabled: Boolean(organizationId),
        queryKey: [organizationId, 'users-with-memberships'],
        queryFn: () => client.fetchApi<UserWithMembershipsDto[], {}>({
            endpoint: `users/with-memberships?organizationId=${organizationId}`,
            method: 'GET'
        }),
    });
};
